export default "__VITE_ASSET__DPAwbtRb__"